import React from 'react';

import { isMessageBounced } from 'stream-chat-react';

import type { LocalMessage } from 'stream-chat';

export interface MessageErrorTextProps {
  message: LocalMessage;
  theme: string;
}

export function CustomMessageErrorText({ message, theme }: MessageErrorTextProps) {
  if (message.type === 'error' && !isMessageBounced(message)) {
    return (
      <div
        className={`str-chat__${theme}-message--error-message str-chat__message--error-message`}
      >
        {'Error · Unsent'}
      </div>
    );
  }

  if (message.status === 'failed') {
    return (
      <div
        className={`str-chat__${theme}-message--error-message str-chat__message--error-message`}
      >
        {message.error?.status !== 403
          ? 'Message Failed · Click to try again'
          : 'Message Failed · Unauthorized'}
      </div>
    );
  }

  return null;
}